import { apiClient } from "./ApiClient";

export const retrieveAllMenuItemsApi = () =>
  apiClient.get(`/menu-item-view/menu-items`);

export const retrieveMenuItemsByTypeApi = (type) =>
  apiClient.get(`/menu-item-view/menu-items/${type}`);

export const retrieveAllMenuItemsByTypeApi = (type) =>
  apiClient.get(`/menu-item-view/menu-items/${type}/all`);

export const createMenuItemApi = (menuItem) =>
  apiClient.post(`/menu-item-view/menu-items`, menuItem);

export const updateMenuItemApi = (menuItemId, menuItem) =>
  apiClient.put(`/menu-item-view/menu-items/${menuItemId}`, menuItem);

export const deleteMenuItemApi = (menuItemId) =>
  apiClient.delete(`/menu-item-view/menu-items/${menuItemId}`);

export const deleteMultipleMenuItemsApi = (idList) =>
  apiClient.put(`/menu-item-view/menu-items/delete-multiple`, idList);

export const restoreMenuItemApi = (menuItemId) =>
  apiClient.put(`/menu-item-view/menu-items/${menuItemId}/restore`);

export const retrieveMenuItemByIdApi = (menuItemId) =>
  apiClient.get(`/menu-item-view/menu-items/get/${menuItemId}`);

export const retrieveAllMenuItemTypesApi = () =>
  apiClient.get(`/menu-item-view/menu-item-types`);